import { useRef } from 'react';
import { loadStripe, Stripe } from '@stripe/stripe-js';
export interface StripeConfigProps {
  publishableKey: string | undefined;
  customerSessionClientSecret: string | undefined;
  availablePaymentMethods?: string[];
}

export function useStripeConfig({
  publishableKey,
  customerSessionClientSecret,
  availablePaymentMethods = ['card'],
}: StripeConfigProps) {
  const stripePromiseRef = useRef<Promise<Stripe | null> | null>(null);

  if (!publishableKey || !customerSessionClientSecret) {
    return;
  }

  // Only initialize stripePromise once
  if (!stripePromiseRef.current) {
    stripePromiseRef.current = loadStripe(publishableKey);
  }

  return {
    stripePromise: stripePromiseRef.current,
    customerSessionClientSecret,
    availablePaymentMethods,
  };
}
